import { Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS } from "@/config";
import { SOCIALS, waLink } from "@/config";
import { WaIcon } from "./Nav";

const TikTok = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M21 8.5a6.3 6.3 0 0 1-4.6-2v7.6a5.9 5.9 0 1 1-5.9-5.9c.3 0 .7 0 1 .1v3a2.9 2.9 0 1 0 2 2.8V2h2.9a6.3 6.3 0 0 0 4.6 5.4z" />
  </svg>
);

const goTo = (hash) => (e) => {
  e.preventDefault();
  if (window.__lenis) window.__lenis.scrollTo(hash, { offset: -90 });
  else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};

const socialItems = [
  { name: "Instagram", href: SOCIALS.instagram, icon: <Instagram size={17} />, testid: "social-instagram" },
  { name: "TikTok", href: SOCIALS.tiktok, icon: <TikTok />, testid: "social-tiktok" },
];

const Footer = () => (
  <footer id="contacto" className="border-t border-white/10 pt-16 pb-8">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div>
          <Logo size={36} />
          <p className="mt-4 max-w-xs text-sm text-white/50 leading-relaxed">
            Lavado y detailing premium a domicilio. El brillo que tu coche merece, sin moverte de casa.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {socialItems.map((s) => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={s.name}
                data-testid={s.testid}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/12 text-white/70 transition-all duration-300 hover:border-aqua hover:text-aqua hover:shadow-[0_0_20px_rgba(0,242,254,0.25)]"
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        <nav className="flex flex-col gap-3">
          <p className="font-mono text-[11px] tracking-[0.25em] text-white/40 uppercase">Navegación</p>
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={goTo(l.href)}
              className="text-sm text-white/60 hover:text-aqua transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={waLink("Hola, quiero información sobre vuestros servicios.")}
            target="_blank"
            rel="noreferrer"
            className="text-sm text-wa hover:underline underline-offset-4"
          >
            WhatsApp directo
          </a>
        </nav>
      </div>

      <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/10 pt-6">
        <p className="font-mono text-[11px] text-white/35">
          © {new Date().getFullYear()} fullshine.detailing — Todos los derechos reservados
        </p>
        <p className="font-mono text-[11px] text-white/35 tracking-[0.2em] uppercase">
          Hecho con brillo
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
